export const BANNER_CONSTANTS = {
  TELEGRAM: {
    URL: 'https://t.me/dubai_insiders_club',
    ICON: 'telegram-icon',
    TEXT: 'Join our Telegram Channel'
  },
  
  PRELAUNCH: {
    TITLE: 'Never miss a Pre-Launch Drop!',
    DESCRIPTION: "Our Telegram channel is where Dubai's most lucrative property deals drop first. Members receive priority access, early pricing, and VIP offers.",
  },
  
  SERVICES: {
    TITLE: 'Premium Services Available',
    DESCRIPTION: 'Get exclusive access to our premium property consultation services.',
    LEFT_PILL_DEFAULT: '3 Services Used',
    RIGHT_TEXT_DEFAULT: 'Insider Level',
  },
  
  UPGRADE: {
    TEXT: 'Exclusive for premium members',
    LINK_TEXT: 'Upgrade Now'
  }
} as const

export const BANNER_VARIANTS = {
  PRELAUNCH: 'prelaunch',
  SERVICES: 'services',
  TRAINING: 'training',
  DEFAULT: 'default'
} as const

export const BANNER_COLORS = {
  PRELAUNCH_BG: '#FFE9C8',
  SERVICES_BG: '#F8F7F3',
  BUTTON_PRIMARY: '#2BABEE',
  BUTTON_HOVER: '#2396D1',
  BORDER: '#E7E7E8',
  BORDER_ACCENT: '#FFC56D',
  TEXT_PRIMARY: '#197BAE'
} as const